import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ForecastEvaluationReport, ForecastOptions, ForecastReport } from '@contracts/interfaces/workload-forecast.interface';
import { ConnectionService } from './connection.service';

@Injectable({ providedIn: 'root' })
export class WorkloadForecastService {
  constructor(private http: HttpClient, private connection: ConnectionService) {}
  get(options: Partial<ForecastOptions> = {}, refresh = false) {
    return this.http.post<ForecastReport>(this.connection.address + '/forecast-service/results', { options, refresh }, { headers: this.headers() });
  }
  evaluation() {
    return this.http.post<ForecastEvaluationReport>(this.connection.address + '/forecast-service/evaluation', { limit: 30 }, { headers: this.headers() });
  }
  private headers(): HttpHeaders {
    const token = this.connection.activeConnection?.token || localStorage.getItem('token') || '';
    return token ? new HttpHeaders({ authtoken: token }) : new HttpHeaders();
  }
}
